import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { memo, useContext } from 'react';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import * as S from './styles';
export const GroupingElement = memo(function GroupingElement(props) {
    const { children, addToPanel, in_panel } = props;
    const { grouping_mode } = useContext(DeviceUISettingsContent);
    return (_jsx(Box, { onClick: addToPanel, height: "100%", children: _jsx(S.GroupingElement, { in_panel: in_panel, grouping_mode: grouping_mode, children: children }) }));
});
